function ContactUs() {
  return (
    <div class="content" style={{ padding: 20 }}>
      <h2>Contact Us</h2>
      <p>Content soon to come.</p>
    </div>
  );
}

export default ContactUs;